/*currency symbol*/


$( document ).ready(function() {
  $("html").attr("data-page-url", window.location.pathname);
  
  var currencySymbol = $( ".currencies option:selected" ).text();
  var splitCurrencySymbol = currencySymbol.split(' ', 1)[0];
  setTimeout(function() { 
  var checkStr = $( ".nosto_element span.money" ).text();
  if(checkStr.includes('TWD') || checkStr.includes('THB') || checkStr.includes('HK') || checkStr.includes('SGD') ){
  }else{
   $('.nosto_element span.money').append(' ' + splitCurrencySymbol);
  }
  
  }, 2000);

});



$(document).on('click', '.custom-hide-filter-btn', function() {
  console.log('test', prodGridCols - 1);
  $("#main-collection-filters").removeClass("active");
  $(".custom-show-filter-btn").show();
  $("#product-grid").removeClass(`grid--${prodGridCols - 1}-col-desktop`).addClass(`grid--${prodGridCols}-col-desktop`);
})
$(document).on('click', '.custom-filter-toggle .custom-show-filter-btn', function() {
  //$(this).hide();
  $("#main-collection-filters").toggleClass("active");
  $("#product-grid").removeClass(`grid--${prodGridCols}-col-desktop`).toggleClass(`grid--${prodGridCols - 1}-col-desktop`);
})
$(document).on("click", ".custom-filter-toggle .custom-filter-toggle-btn, .custom-mobile-filter-overlay, .custom-mobile-filter-close", function(){
  $(".facets-vertical facet-filters-form").toggleClass("active");
  $(".custom-mobile-filter-overlay").fadeToggle(300);
})
$(document).on("click", ".custom-pg-quick-view-btn, .custom-quick-view-popup-close, .custom-quick-view-popup-wrapper", function(e){
  e.preventDefault();
  if($(this).parents(".custom-pg-main-wrapper").length > 0){
    $(this).parents(".custom-pg-main-wrapper").find(".custom-quick-view-popup-wrapper").toggleClass("active");
    $(".custom-pg-variant-option-details").removeAttr("open");
  }
  else{
    $(`.custom-quick-view-popup-wrapper`).removeClass("active");
  }
})
$(document).on("click", ".custom-pg-quick-view-btn-new", function(e){
  e.preventDefault();
  $(".custom-quick-view-popup-wrapper").removeClass("active")
  $(`.custom-quick-view-popup-wrapper[data-id="${$(this).attr("data-id")}"]`).addClass("active");
  // $(`.custom-quick-view-popup-wrapper[data-id="${$(this).attr("data-id")}"]`).find(".custom-pg-colors-hide").find(".custom-pg-variant-option-input").eq(0).prop("checked", true);
  $(".custom-pg-variant-option-details").removeAttr("open");
  
})
$(document).on("click", ".custom-quick-view-popup", function(e){
  e.stopPropagation();
  $(".custom-pg-variant-option-details").removeAttr("open");
})
$(document).on("click", ".custom-pg-variant-option-label", function(){
  $(this).parents(".custom-pg-variant-option-details").find(".custom-pg-variant-option-summary").find("span").text($(this).prev().val());
  $(this).parents(".custom-quick-view-popup-info").find(".custom-pg-atc").removeClass("first_click");
})
$(document).on("change", ".custom-pg-variant-option-input", function(){
  if($(this).hasClass("custom-pg-variant-option-input---color")){
    $(this).parents(".custom-pg-variant-option-details").find(".custom-pg-variant-option-summary").find("span").text($(this).val());
  }
  else{
    $(this).parents(".custom-pg-variant-option-details").find(".custom-pg-variant-option-summary").attr("data-color", $(this).attr("data-color"));
    $(this).parents(".custom-pg-variant-option-details").find(".custom-pg-variant-option-summary").find("span").text($(this).val());
  }

  let final = "";
  $(this).parents(".custom-pg-variants-wrapper").find(".custom-pg-variant-option-input:checked").each(function(){
    final += $(this).val() + " / ";
  })
  final = final.substring(0, final.length - 2).trim();
  let btn = $(this).parents(".custom-quick-view-popup-info").find(".custom-pg-atc");
  let price = $(this).parents(".custom-quick-view-popup-info").find(".custom-quick-view-popup-price");
  console.log(final);
  let found = false;
  $(this).parents(".custom-quick-view-popup-info").find(".custom-pg-master-select option").each(function(){
    if($(this).text().trim() == final){
      console.log($(this).text().trim(), final, "matching")
      $(this).parents(".custom-quick-view-popup-info").find(".custom-pg-master-select").val($(this).val()).trigger("change");
      found = true;
      console.log($(this).parents(".custom-quick-view-popup-info").find(".custom-pg-master-select").val(), $(this).attr("data-available"), btn)
      price.html($(this).attr("data-price"));
      if($(this).attr("data-available") == "false"){
        btn.addClass("sold").text("Sold Out");
      }
      else{
        btn.removeClass("sold").text("Add to Bag");
        btn.attr("data-id", $(this).val());
      }
    }
  })
  if(!found){
    btn.addClass("sold").text("Unavailable");
  }
})
$(document).on("click", ".custom-pg-atc", function(){
  let $this = $(this);
  $(this).addClass("active");
  let id = $(this).attr("data-id");
  let formData = {
    'items': [{
     'id': id,
     'quantity': 1
     }],
    sections: "cart-drawer,cart-icon-bubble"
   };
   fetch(window.Shopify.routes.root + 'cart/add.js', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json',
       'X-Requested-With': 'xmlhttprequest'
     },
     body: JSON.stringify(formData)
   })
   .then(response => {
     return response.json();
   })
   .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      $this.removeClass("active");
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      $(".cart-count-bubble").trigger("click");
    }
   })
   .catch((error) => {
     console.error('Error:', error);
   })
   .finally(function(){
      $this.removeClass("active");
   });
})


const customDebounce = (fn, wait, immediate = false) => {
  let timer;
  return function(...args) {
    const callNow = immediate && !timer;
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (!immediate) fn.apply(this, args);
    }, wait);
    if (callNow) fn.apply(this, args);
  };
};

// $(document).click(function(){
//   $(".custom-search-results-main-wrapper").hide();
// })
// $(document).on("click", ".custom-search-mobile-toggle, .custom-search-close", function(e){
//   e.stopPropagation();
//   $(".custom-search-form-wrapper").toggleClass("active");
// })
// $(document).on("click", ".custom-search-input", function(e){
//   e.stopPropagation();
//   if($(this).val().length > 0){
//     $(".custom-search-results-main-wrapper").show();
//   }
//   else{
//     $(".custom-search-results-main-wrapper").hide();
//   }
// })
// $(document).on("change input paste", ".custom-search-input", customDebounce(function(){
//   let val = $(this).val();
//   if(val.length > 0){
//     $(".custom-search-results-main-wrapper").show();
//   }
//   else{
//     $(".custom-search-results-main-wrapper").hide();
//   }
//   const predictiveSearchSection = document.querySelector('.custom-search-results-main-wrapper');
//   var requestResponse;
  
//   fetch(window.Shopify.routes.root + `search/suggest?q=${val}&esources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&resources[limit_scope]=each&section_id=custom-search`)
//     .then((response) => {
//       requestResponse = response;
//       return response.text();
//      })
//     .then((text) => {
//       if (!requestResponse.ok) {
//         throw new Error(`${requestResponse.status}: ${text}`);
//       }
  
//       const resultsMarkup = new DOMParser()
//         .parseFromString(text, 'text/html')
//         .querySelector('.shopify-section').innerHTML;
  
//       predictiveSearchSection.innerHTML = resultsMarkup;
//     })
//     .catch((error) => {
//       console.error(error);
//     });
// }, 300))

// ===== SEARCH (scoped to nearest form) =====
$(document).click(function () {
  $('.custom-search-results-main-wrapper').hide();
});

// Toggle only the wrapper related to the clicked control
$(document).on('click', '.custom-search-mobile-toggle, .custom-search-close', function (e) {
  e.stopPropagation();
  // Works for both desktop (.custom-search-form-wrapper) and mobile (.jci-mobile-search)
  const $scopeWrapper = $(this).closest('.custom-search-form-wrapper, .jci-mobile-search');
  $scopeWrapper.toggleClass('active');
});

$(document).on('click', '.custom-search-input', function (e) {
  e.stopPropagation();
  const $scope   = $(this).closest('.custom-search-form-inner');
  const $results = $scope.find('.custom-search-results-main-wrapper');
  if ($(this).val().trim().length > 0) $results.show(); else $results.hide();
});

// Keep clicks inside results from closing them
$(document).on('click', '.custom-search-results-main-wrapper', function (e) {
  e.stopPropagation();
});

// Debounced predictive search — scoped to the nearest form
$(document).on('change input paste', '.custom-search-input', customDebounce(function () {
  const $scope   = $(this).closest('.custom-search-form-inner');
  const $results = $scope.find('.custom-search-results-main-wrapper');
  const val      = ($(this).val() || '').trim();

  if (!val) { $results.empty().hide(); return; }
  $results.show();

  let requestResponse;
  const url =
    window.Shopify.routes.root +
    `search/suggest?q=${encodeURIComponent(val)}&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&resources[limit_scope]=each&section_id=custom-search`; // <-- fixed "resources"

  fetch(url)
    .then((response) => {
      requestResponse = response;
      return response.text();
    })
    .then((text) => {
      if (!requestResponse.ok) throw new Error(`${requestResponse.status}: ${text}`);
      const html = new DOMParser().parseFromString(text, 'text/html')
                    .querySelector('.shopify-section').innerHTML;
      $results.html(html).show();
    })
    .catch((error) => {
      console.error(error);
      $results.hide();
    });
}, 300));

$(document).on("click", `a[href="#popup"]`, function(e){
  e.preventDefault();
  if($(".size-guide-link").length > 0){
    $(".size-guide-link")[0].dispatchEvent(new Event('click'));
  }
})


$(document).on("click", ".custom-drawer-free-prod-atc", function(){
  let $this = $(this);
  $(this).addClass("active");
  let id = $(this).attr("data-id");
  let formData = {
    'items': [{
     'id': id,
     'quantity': 1,
     'properties': {
      '_free_gift': true
     }
     }],
    sections: "cart-drawer,cart-icon-bubble"
   };
   fetch(window.Shopify.routes.root + 'cart/add.js', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json',
       'X-Requested-With': 'xmlhttprequest'
     },
     body: JSON.stringify(formData)
   })
   .then(response => {
     return response.json();
   })
   .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      $this.removeClass("active");
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
    }
   })
   .catch((error) => {
     console.error('Error:', error);
   })
   .finally(function(){
      $this.removeClass("active");
   });
})